module.exports = __webpack_public_path__ + "static/media/logo.e55cae04.png";